<div class="container">
  <div class="text-center justify-content-center">
    <h1 class="mainHeading">Order History</h1>
  </div>

  <!-- Search Box Section -->
  <div class="row mt-3 align-items-end justify-content-between">
    <!-- Button (aligned to start) -->
    <div class="col-md-2 col-sm-6">
      <button class="btn btn-outline-secondary w-100" type="button">
        <i class="bi bi-box-arrow-up me-2"></i> Export
      </button>
    </div>

    <div class="col-md-2 col-sm-6">
      <button
        class="btn btn-outline-secondary ms-2"
        type="button"
        (click)="exportToPDF()"
      >
        <span><i class="bi bi-printer me-2"></i></span>
        Print
      </button>
    </div>

    <!-- Wrapper for City, Zone, and Search fields (aligned to end) -->
    <div class="col-md-9">
      <div class="row g-2 justify-content-end">
        <div class="col-md-4 col-sm-6">
          <label for="search" class="form-label">Search</label>
          <input
            id="search"
            type="text"
            class="form-control"
            placeholder="Search..."
            (input)="onSearch($event)"
          />
        </div>
      </div>
    </div>
  </div>

  <!-- Tabs Navigation -->
  <div class="card p-3 shadow-lg mt-3">
    <ul class="nav nav-tabs cursor-pointer mt-3" id="myTab" role="tablist">
      <li class="nav-item cursor-pointer" role="presentation">
        <a
          class="nav-link cursor-pointer"
          [class.active]="activeTab === 'total-order'"
          (click)="setActiveTab('total-order')"
        >
          Total Order
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'active-order'"
          (click)="setActiveTab('active-order')"
        >
          Active Order
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'completed-order'"
          (click)="setActiveTab('completed-order')"
        >
          Completed Order
        </a>
      </li>
      <li class="nav-item" role="presentation">
        <a
          class="nav-link"
          [class.active]="activeTab === 'cancelled-order'"
          (click)="setActiveTab('cancelled-order')"
        >
          Cancelled Order
        </a>
      </li>
    </ul>

    <!-- Tab Content -->
    <div class="tab-content">
      <div class="tab-pane fade show active mt-3">
        <div class="table-responsive" style="max-width: 100%; overflow-x: auto">
          <table class="table table-bordered table-striped table-hover">
            <thead>
              <tr class="cursor-pointer">
                <th>Order Id</th>
                <th>Requestor Type</th>
                <th>Requestor Name</th>
                <th>Requestor mobile no</th>
                <th>Request Date</th>
                <th>Scheduled Date</th>
                @if(activeTab != 'cancelled-order') {
                <th>Dumpster Name</th>
                <th>Dumpster mobile no</th>
                <th>Dump Yard Name</th>
                <th>Dump Yard Mobile No</th>
                }
                <th>
                  City
                  <i
                    class="bi bi-funnel"
                    id="dumpedStatusDropdown"
                    data-bs-toggle="dropdown"
                  ></i>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dumpedStatusDropdown"
                  >
                    <li (click)="filterData('city', 'All')">
                      <a class="dropdown-item">All</a>
                    </li>
                    <li
                      *ngFor="let city of uniqueCities"
                      (click)="filterData('city', city)"
                    >
                      <a class="dropdown-item"> {{ city }}</a>
                    </li>
                  </ul>
                </th>
                <th>
                  Status
                  <i
                    class="bi bi-funnel"
                    id="dumpedStatusDropdown"
                    data-bs-toggle="dropdown"
                  ></i>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dumpedStatusDropdown"
                  >
                    <li (click)="filterData('status', 'All')">
                      <a class="dropdown-item">All</a>
                    </li>
                    <li
                      *ngFor="let status of uniqueyOrderStatus"
                      (click)="filterData('status', status)"
                    >
                      <a class="dropdown-item"> {{ status }}</a>
                    </li>
                  </ul>
                </th>
                <th>Dumpster Payment</th>
                <th>Dumpyard Payment</th>
                <th>Requestor Payment</th>
                <th>Payment Details</th>
                <th>Order Timeline</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of currentPageData; let i = index">
                <!-- <td class="text-center">{{ (currentPage - 1) * pageSize + i + 1 }}</td> -->
                <td
                  class="hyperLink"
                  (click)="openDetailModal(detailsModal, row)"
                  class="text-center custom-column-width"
                >
                  <a class="hyperLink">{{ row.orderId }}</a>
                </td>
                <td class="text-center">{{ row.requestorType }}</td>
                <td class="text-center">
                  {{
                    row.requestorType == "Individual Requester"
                      ? row.requestorName
                      : row.companyName
                  }}
                </td>
                <td class="text-center">{{ row.requestorMobile }}</td>
                <td class="text-center custom-column-width">
                  {{ row.requestDate | date : "dd MMM yyy" }}
                </td>
                <td class="text-center custom-column-width">
                  {{ row.scheduledDate | date : "dd MMM yyy" }}
                </td>
                @if(activeTab != 'cancelled-order') {
                <td class="text-center">{{ row.dumbsterCompanyName }}</td>
                <td class="text-center">{{ row.dumpsterMobileNo }}</td>
                <td class="text-center custom-column-width">
                  {{
                    row.currentOrderStatusID == 114
                      ? "-"
                      : row.dumpyardCompanyName
                  }}
                </td>
                <td class="text-center custom-column-width">
                  {{
                    row.currentOrderStatusID == 114 ? "-" : row.dumpyardMobileNo
                  }}
                </td>
                }
                <td class="text-center">{{ row.city }}</td>
                <td class="text-center">{{ row.statusToDisplay }}</td>

                <!-- Display Payment Details -->
                <td class="text-center">
                  <span
                    [ngClass]="{
                      'badge text-bg-success':
                        row.currentOrderStatusID != 114 &&
                        row.dumbsterAmt != null
                    }"
                  >
                    {{
                      row.currentOrderStatusID == 114
                        ? "N/A"
                        : getPaymentStatus(row.dumpsterStatusCode)
                    }}
                  </span>
                </td>
                <td class="text-center">
                  <span
                    [ngClass]="{
                      'badge text-bg-success':
                        row.currentOrderStatusID != 114 &&
                        row.dumbYardAmt != null
                    }"
                  >
                    {{
                      row.currentOrderStatusID == 114
                        ? "N/A"
                        : getPaymentStatus(row.dumpyardStatusCode)
                    }}
                  </span>
                </td>
                <td class="text-center">
                  <span
                    [ngClass]="{
                      'badge text-bg-success':
                        row.currentOrderStatusID != 114 &&
                        row.requestRefundAmt != null
                    }"
                  >
                    {{
                      row.currentOrderStatusID == 114
                        ? "N/A"
                        : getPaymentStatus(row.requesterStatusCode)
                    }}
                  </span>
                </td>

                <td
                  class="hyperLink"
                  (click)="openPaymentPopup(row, paymentDetailsModal)"
                >
                  View Details
                </td>
                <td
                  class="text-center hyperLink"
                  (click)="navigate(row?.orderId)"
                >
                  View Timeline
                </td>
                <td
                  class="text-center hyperLink"
                  (click)="
                    openDownloadInvoiceModal(
                      row?.orderId,
                      downloadInvoiceModal,
                      row
                    )
                  "
                >
                  <i ngbTooltip="Download Invoice" class="fas fa-download"></i>
                </td>
              </tr>
              <tr *ngIf="!currentPageData || currentPageData.length === 0">
                <td class="text-center" colspan="17">
                  <h3>No data available</h3>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Pagination Controls -->
    <div
      class="d-flex mt-2 justify-content-center"
      *ngIf="requestData?.length > 0"
    >
      <ngb-pagination
        [(page)]="currentPage"
        [pageSize]="pageSize"
        [collectionSize]="totalItems"
        (pageChange)="pageChanged($event)"
        [maxSize]="3"
        [boundaryLinks]="true"
      >
      </ngb-pagination>
    </div>
    <div *ngIf="currentPageData?.length > 0" class="text-muted text-end mb-3">
      <strong
        >Showing {{ (currentPage - 1) * pageSize + 1 }} to
        {{
          currentPage * pageSize > currentPageData?.length
            ? currentPageData?.length
            : currentPage * pageSize
        }}
        of {{ currentPageData?.length }} entries</strong
      >
    </div>
  </div>
</div>

<!--------------------------------- Details popup --------------------------------->

<ng-template #detailsModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Order Details - ({{ selectedOrderId }})</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form [formGroup]="orderForm">
    <div class="modal-body custom-modal">
      <!-- User Type Form Group -->
      <div class="mb-3 row">
        <label for="userType" class="col-sm-4 col-form-label text-start"
          >Requestor Type</label
        >
        <div class="col-sm-8">
          <input
            id="userType"
            formControlName="userType"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Company Name Form Group -->
      <div class="mb-3 row">
        <label for="companyName" class="col-sm-4 col-form-label text-start">
          Name</label
        >
        <div class="col-sm-8">
          <input
            id="companyName"
            formControlName="companyName"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Mobile Number Form Group -->
      <div class="mb-3 row">
        <label for="mobileNumber" class="col-sm-4 col-form-label text-start">
          Mobile Number</label
        >
        <div class="col-sm-8">
          <input
            id="mobileNumber"
            formControlName="mobileNumber"
            class="form-control"
            [readonly]="true"
            type="text"
          />
        </div>
      </div>

      <!-- Address Form Group -->
      <div class="mb-3 row">
        <label for="location" class="col-sm-4 col-form-label text-start">
          Location</label
        >
        <div class="col-sm-8">
          <textarea
            id="location"
            formControlName="location"
            class="form-control"
            [readonly]="true"
            rows="3"
          ></textarea>
        </div>
      </div>

      <!-- Email Form Group -->
      <div class="mb-3 row">
        <label for="city" class="col-sm-4 col-form-label text-start"
          >City</label
        >
        <div class="col-sm-8">
          <input
            id="city"
            formControlName="city"
            class="form-control"
            [readonly]="true"
            type="email"
          />
        </div>
      </div>

      <!-- City Form Group -->
      <div class="mb-3 row">
        <label for="zone" class="col-sm-4 col-form-label text-start"
          >Zone</label
        >
        <div class="col-sm-8">
          <input
            id="zone"
            formControlName="zone"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- Zone Form Group -->
      <div class="mb-3 row">
        <label for="reqDate" class="col-sm-4 col-form-label text-start"
          >Request Date & Time</label
        >
        <div class="col-sm-8">
          <input
            id="reqDate"
            formControlName="reqDate"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- Bank Name Form Group -->
      <div class="mb-3 row">
        <label for="scheduledDate" class="col-sm-4 col-form-label text-start"
          >Scheduled Date & Time</label
        >
        <div class="col-sm-8">
          <input
            id="scheduledDate"
            formControlName="scheduledDate"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Container Name No Form Group -->
      <div class="mb-3 row">
        <label for="containerName" class="col-sm-4 col-form-label text-start"
          >Container Type</label
        >
        <div class="col-sm-8">
          <input
            id="containerName"
            formControlName="containerName"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- Bank Account No Form Group -->
      <div class="mb-3 row">
        <label
          for="containerCapacity"
          class="col-sm-4 col-form-label text-start"
          >Container Capacity (m³)</label
        >
        <div class="col-sm-8">
          <input
            id="containerCapacity"
            formControlName="containerCapacity"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- CR Number Form Group -->
      <div class="mb-3 row">
        <label for="containerCount" class="col-sm-4 col-form-label text-start"
          >No Of Containers</label
        >
        <div class="col-sm-8">
          <input
            id="containerCount"
            formControlName="containerCount"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <!-- CR Document Form Group -->
      <div class="mb-3 row">
        <label for="rentalDuration" class="col-sm-4 col-form-label text-start"
          >Rental Duration (Week)</label
        >
        <div class="col-sm-8">
          <input
            id="rentalDuration"
            formControlName="rentalDuration"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>

      <div class="mb-3 row">
        <label for="sar" class="col-sm-4 col-form-label text-start">SAR</label>
        <div class="col-sm-8">
          <input
            id="sar"
            formControlName="sar"
            [readonly]="true"
            class="form-control"
          />
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #downloadInvoiceModal let-modal>
  <div class="modal-header custom-modal-header">
    <h3 class="modal-title mt-3">Download Invoice</h3>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>

  <div class="modal-body custom-modal">
    <p>Choose the invoice type:</p>
    <select
      class="form-select"
      aria-label="Invoice type"
      [(ngModel)]="invoiceType"
    >
      <!-- <option selected value="">Select invoice type</option> -->
      <option selected value="Initial Requestor Invoice">
        Initial Requestor Invoice
      </option>
      <option
        value="Requestor Refund Invoice"
        [disabled]="requesterStatusCode == null || requesterStatusCode == '0'"
      >
        Requestor Refund Invoice
      </option>
      <option
        value="Dumpster Invoice"
        [disabled]="dumpsterStatusCode == null || dumpsterStatusCode == '0'"
      >
        Dumpster Invoice
      </option>
      <option
        value="Dump Yard Invoice"
        [disabled]="dumpyardStatusCode == null || dumpyardStatusCode == '0'"
      >
        Dump Yard Invoice
      </option>
    </select>
    <button
      type="button"
      class="btn btn-primary mt-3 mb-2"
      (click)="downLoadInvoice()"
    >
      Download
    </button>
  </div>
</ng-template>

<ng-template #paymentDetailsModal let-modal>
  <div class="modal-header custom-modal-header">
    <h2 class="modal-title mt-3">Payment Details</h2>
    <button
      type="button"
      class="btn-close"
      style="background-color: white !important"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    ></button>
  </div>
  <form [formGroup]="paymentForm">
    <div
      class="modal-body custom-modal"
      style="max-height: 500px; overflow-y: scroll"
    >
      <!-- Requestor Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Requester
      </h2>
      <div class="mb-3 row">
        <label for="sarReceivedReq" class="col-sm-4 col-form-label text-start">
          SAR Received</label
        >
        <div class="col-sm-8">
          <input
            id="sarReceivedReq"
            formControlName="sarReceivedReq"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>
      <div class="mb-3 row">
        <label for="sarRefundedReq" class="col-sm-4 col-form-label text-start"
          >SAR Refunded</label
        >
        <div class="col-sm-8">
          <input
            id="sarRefundedReq"
            formControlName="sarRefundedReq"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Dumpster Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Dumpster
      </h2>
      <div class="mb-3 row">
        <label for="sarDumpster" class="col-sm-4 col-form-label text-start"
          >SAR Credited</label
        >
        <div class="col-sm-8">
          <input
            id="sarDumpster"
            formControlName="sarDumpster"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Dump Yard Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Dump yard
      </h2>
      <div class="mb-3 row">
        <label for="sarDumpyard" class="col-sm-4 col-form-label text-start"
          >SAR Credited</label
        >
        <div class="col-sm-8">
          <input
            id="sarDumpyard"
            formControlName="sarDumpyard"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>

      <!-- Smartsort Bank Details -->
      <h2 class="text-center" style="background-color: #8e0e00; color: white">
        Smart-Sort
      </h2>
      <div class="mb-3 row">
        <label for="sarSmartSort" class="col-sm-4 col-form-label text-start"
          >SAR Credited</label
        >
        <div class="col-sm-8">
          <input
            id="sarSmartSort"
            formControlName="sarSmartSort"
            class="form-control"
            [readonly]="true"
          />
        </div>
      </div>
    </div>
  </form>
</ng-template>

<ngx-spinner
  bdColor="rgba(0,0,0,0.1)"
  color="#8E0E00"
  size="default"
  type="ball-clip-rotate"
></ngx-spinner>
